<template>
  <div id="p-url-maker">
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="ide环境">
        <el-radio-group v-model="form.mode">
          <el-radio label="ide-edit">编程模式</el-radio>
          <el-radio label="ide-preview">预览模式</el-radio>
          <el-radio label="ide-run">教师运行模式</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="编程语言">
        <el-radio-group v-model="form.language">
          <el-radio v-for="item in languages" :key="item" :label="item"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.language == python" label="本地运行">
        <el-switch v-model="form.rlocal"></el-switch>
      </el-form-item>
      <el-form-item label="编辑器黑色">
        <el-switch v-model="form.theme"></el-switch>
      </el-form-item>
      <el-form-item label="按钮状态">
        <el-checkbox-group v-model="form.type">
          <el-checkbox :label="signBit.run" name="type">运行按钮</el-checkbox>
          <el-checkbox :label="signBit.test" name="type">测试按钮</el-checkbox>
          <el-checkbox :label="signBit.save" name="type">保存按钮</el-checkbox>
          <el-checkbox :label="signBit.answers" name="type">测试记录</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="输出url">
        <el-input type="textarea" v-model="getUrl"></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button @click="goClick">前往</el-button>
      </el-form-item>
      <el-divider>...</el-divider>
      <el-form-item label="输入url">
        <el-input v-model="inUrl"></el-input>
      </el-form-item>
      <el-form-item align="center">
        <el-button type="success" @click="onSubmit" :disabled="!inUrl">验证</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Language from '../scripts/common/language'
import Env from '../scripts/common/env'
export default {
  name: 'p-url-maker',
  data() {
    return {
      form: {
        mode: 'ide-edit',
        language:  Language.c.key,
        rlocal: false,
        theme: false,
        type: [],
      },
      inUrl: ''
    }
  },
  computed: {
    languages() {
      return Object.keys(Language);
    },
    python() {
      return Language.py.key;
    },
    signBit() {
      return Env.signBit;
    },
    getUrl() {
      // ideParams
      let ip = Env.signBit.mixin
      if (this.form.rlocal) {
        ip += Env.signBit.rlocal
      }
      for (const t of this.form.type) {
        if (t) {
          ip += t
        }
      }
      let url = `${location.origin}/${this.form.mode}?ip=${ip}&lang=${this.form.language}`
      if (this.form.theme) {
        url = `${url}&theme=1`
      }
      return url
    }
  },
  created() {
  },
  methods: {
    goClick() {
      // location.href = this.getUrl;
      this.$router.push(this.getUrl.substr(this.getUrl.lastIndexOf('/')))
    },
    getQueryString(search, name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      let r = search.match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    onSubmit() {
      const urlArr = this.inUrl.split('?')
      this.form.mode = urlArr[0].slice(urlArr[0].lastIndexOf('/') + 1)
      this.form.language = this.getQueryString(urlArr[1], 'lang')

      const theme = this.getQueryString(urlArr[1], 'theme')
      this.form.theme = theme === '1' || theme === 'true'

      let ip = this.getQueryString(urlArr[1], 'ip')
      ip = ip && parseInt(ip, 10) || 0
      this.form.rlocal = ip & Env.signBit.rlocal ? true : false,
      this.form.type = [
        ip & Env.signBit.run ? Env.signBit.run : 0,
        ip & Env.signBit.test ? Env.signBit.test : 0,
        ip & Env.signBit.save ? Env.signBit.save : 0,
        ip & Env.signBit.answers ? Env.signBit.answers : 0,
      ]
      console.log('submit!');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  #p-url-maker {
    margin: auto;
    width: 700px;
  }
</style>
